'use client';
import Image from 'next/image';
import { useState } from 'react';

const JobAndtalentMatchingImage = '/images/JobAndTalentMatching/JobAndTalentMatching.webp';

interface StepItemProps {
  title: string;
  content: string;
  isOpen: boolean;
  onClick: () => void;
}

const StepItem = ({ title, content, isOpen, onClick }: StepItemProps) => {
  return (
    <div
      onClick={onClick}
      className="bg-policeblue-dark rounded-lg p-4 md:p-6 lg:p-8 flex cursor-pointer flex-col"
    >
      <div className="space-y-4">
        <h3 className="text-stonerwhite flex items-center justify-between">
          {title}

          <span className="text-orange text-xl">{isOpen ? '-' : '+'}</span>
        </h3>

        {isOpen && (
          <p className="text-verylightgrey" dangerouslySetInnerHTML={{ __html: content }} />
        )}
      </div>
    </div>
  );
};

const TalentAndJobMatching = () => {
  const [openIndex, setOpenIndex] = useState<number>(0);

  const handleClick = (index: number) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? -1 : index));
  };

  return (
    <section className="bg-stonerwhite gap-4 p-4 sm:p-8 md:p-10 lg:p-12 flex flex-wrap justify-center">
      <div className="max-w-6xl m-auto flex flex-col">
        <h2 className="text-policeblue-dark lb:pb-12 pb-4 font-bold sm:pb-8 md:pb-10 flex justify-center">
          Correspondance entre les compétences et le poste
        </h2>

        <div className="gap-4 md:flex-row flex flex-col">
          <div className="md:w-5/12 flex w-full items-center">
            <div className="md:p-4 rounded-lg relative flex w-full flex-col items-center">
              <Image
                alt="..."
                src={JobAndtalentMatchingImage}
                className="rounded-lg shadow-lg w-full"
                width={1920}
                height={1440}
              />
            </div>
          </div>

          <div className="gap-4 md:w-6/12 mx-auto flex w-full flex-col">
            <div className="gap-4 sm:pl-4 md:pl-6 lg:pl-8 xl:pl-10 flex flex-col">
              <StepItem
                title="Collecte des besoins"
                content="Les entreprises précisent leurs besoins spécifiques, au-delà des fiches de poste classiques."
                isOpen={openIndex === 0}
                onClick={() => handleClick(0)}
              />

              <StepItem
                title="Analyse des compétences"
                content="L'outil d'analyse croisée évalue les compétences, expériences et <i>soft skills</i> des candidats de 45&nbsp;ans et plus."
                isOpen={openIndex === 1}
                onClick={() => handleClick(1)}
              />

              <StepItem
                title="Mise en relation"
                content="Nous identifions les correspondances les plus pertinentes en tenant compte de l'humain et des enjeux technologiques."
                isOpen={openIndex === 2}
                onClick={() => handleClick(2)}
              />

              <StepItem
                title="Validation des correspondances"
                content="Chaque mise en relation est soigneusement validée pour garantir une adéquation parfaite entre le candidat et l'entreprise."
                isOpen={openIndex === 3}
                onClick={() => handleClick(3)}
              />

              <StepItem
                title="Résultat"
                content="Des correspondances durables, opérationnelles et immédiatement efficaces."
                isOpen={openIndex === 4}
                onClick={() => handleClick(4)}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TalentAndJobMatching;
